export default __webpack_public_path__ + "static/media/newsimg4.273c1763.webp";